import { Injectable } from '@angular/core';
import {Stomp} from '@stomp/stompjs';
import {Observable, of, Subject} from "rxjs";
import {filter, map, take} from "rxjs/operators";
import {ServerConnectionService} from "./server-connection.service";
import {HttpClientService} from "./http-client.service";
import * as SockJS from 'sockjs-client';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {

  private url: string;
  stompClient: any;

  subscriberAutotest = new Subject<any[]>();
  observableAutotest: Observable<any[]>;
  subscriberOTA = new Subject<any[]>();
  observableOTA: Observable<any[]>;
  subscriberParametros = new Subject<any>();
  observableParametros: Observable<any>;
  subscriberDaliData = new Subject<any>();
  observableDaliData: Observable<any>;

  private parametrosCache = new Map<string, any>();
  private daliDataCache = new Map<string, any>();
  private peripheralsCache = new Map<string, any>();
  subscriberPeripherals = new Subject<any>();
  observablePeripherals: Observable<any>;

  constructor(private serverConnection: ServerConnectionService, private http: HttpClientService) {
    this.url = serverConnection.getUrlServer();
    this.observableAutotest = this.subscriberAutotest.asObservable();
    this.observableOTA = this.subscriberOTA.asObservable();
    this.observableParametros = this.subscriberParametros.asObservable();
    this.observableDaliData = this.subscriberDaliData.asObservable();
    this.observablePeripherals = this.subscriberPeripherals.asObservable();
    this.connectSock();
  }

  connectSock() {
    let endpoint = '/ws';
    let ws = new (SockJS as any)(this.serverConnection.getUrlServer() + endpoint);
    this.stompClient = Stomp.over(ws);
    const that = this;
    that.stompClient.connect({}, function () {
      that.stompClient.subscribe("/autotest", function (result: any) {
        let data: any[] = JSON.parse(result.body);
        that.subscriberAutotest.next(data);
      });
      that.stompClient.subscribe("/ota", function (result: any) {
        let data: any[] = JSON.parse(result.body);
        that.subscriberOTA.next(data);
      });
      that.stompClient.subscribe("/parametros", function (result: any) {
        let data: any = JSON.parse(result.body);
        that.parametrosCache.set(data.requestId, data);
        that.subscriberParametros.next(data);
      });
      that.stompClient.subscribe("/dali-data", function (result: any) {
        let data: any = JSON.parse(result.body);
        that.daliDataCache.set(data.requestId, data);
        that.subscriberDaliData.next(data);
      });
      that.stompClient.subscribe("/peripherals", function (result: any) {
        let data: any = JSON.parse(result.body);
        that.peripheralsCache.set(data.requestId, data);
        that.subscriberPeripherals.next(data);
      });
      that.stompClient.reconnect_delay = 2000;
    });
  }

  getOberserverAutotest() {
    return this.observableAutotest;
  }

  getOberserverPeripherals() {
    return this.observablePeripherals;
  }

  getOberserverOTA() {
    return this.observableOTA;
  }

  waitForParametrosResponse(requestId: string): Observable<any[]> {
    const cached = this.parametrosCache.get(requestId);
    if (cached) {
      this.parametrosCache.delete(requestId);
      return of(cached.parametros ?? []);
    }

    return this.observableParametros.pipe(
      filter((result: any) => result.requestId === requestId),
      take(1),
      map((result: any) => {
        this.parametrosCache.delete(requestId);
        return result.parametros ?? [];
      })
    );
  }

  waitForDaliDataResponse(requestId: string): Observable<any> {
    const cached = this.daliDataCache.get(requestId);
    if (cached) {
      this.daliDataCache.delete(requestId);
      return of(cached);
    }

    return this.observableDaliData.pipe(
      filter((result: any) => result.requestId === requestId),
      take(1),
      map((result: any) => {
        this.daliDataCache.delete(requestId);
        return result;
      })
    );
  }

  waitForPeripheralsResponse(requestId: string): Observable<any> {
    const cached = this.peripheralsCache.get(requestId);
    if (cached) {
      this.peripheralsCache.delete(requestId);
      return of(cached);
    }

    return this.observablePeripherals.pipe(
      filter((result: any) => result.requestId === requestId),
      take(1),
      map((result: any) => {
        this.peripheralsCache.delete(requestId);
        return result;
      })
    );
  }

}
